import React, { useState } from 'react';
import { DatePicker } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { Box } from '@mui/system';

interface FormikDatePickerProps {
  onChange: (date: string | null) => void;
  minDate?: Date;
  maxDate?: Date;
  label: string;
  required?: boolean;
  fieldValue: { value: string; onBlur?: () => void };
  disabled?: boolean;
  className?: string;
  disablePast?: boolean;
  disableFuture?: boolean;
  initialValue?: string | Date;
}

export const FormikDatePicker: React.FC<FormikDatePickerProps> = ({
  onChange,
  minDate,
  maxDate,
  label,
  disabled = false,
  disablePast = false,
  disableFuture = false,
  initialValue
}) => {
  const [selectedDate, setSelectedDate] = useState<Date | null>(null);

  const handleDateChange = (date: Date | null, context: any) => {
    // Only process the date change if it's not from keyboard input
    if (date && !context.validationError) {
      const month = date.getMonth() + 1;
      const day = date.getDate();
      const year = date.getFullYear();

      const formattedMonth = month.toString().padStart(2, '0');
      const formattedDay = day.toString().padStart(2, '0');
      const dateMDY = `${formattedMonth}-${formattedDay}-${year}`;

      setSelectedDate(date);
      onChange(dateMDY);
    } else if (!date) {
      setSelectedDate(null);
      onChange(null);
    }
  };

  return (
    <Box className="datepicker_field_wrapper">
      <LocalizationProvider dateAdapter={AdapterDateFns}>
        <DatePicker
          label={label}
          value={
            selectedDate
              ? new Date(selectedDate)
              : initialValue
              ? new Date(initialValue)
              : null
          }
          disablePast={disablePast}
          disableFuture={disableFuture}
          onChange={handleDateChange}
          disabled={disabled}
          minDate={minDate}
          maxDate={maxDate}
          slotProps={{
            textField: {
              onKeyDown: (e) => {
                // Prevent keyboard input
                e.preventDefault();
              },
              inputProps: {
                readOnly: true
              },
              fullWidth: true
            }
          }}
        />
      </LocalizationProvider>
    </Box>
  );
};
